// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__1ToRQ","dense":"_type_dense__36Sjo","segmented":"_type_segmented__1TOv3","fill":"_type_fill__1EQP5"};